module.exports = __webpack_public_path__ + "img/bglf-login.73314d9.jpg";